import type { WorkflowNodeType } from '../nodes/types';

export const NODE_WIDTH = 200;
export const EXPANDED_SNIPPET_NODE_HEIGHT = 64;

// additional gutter used to pad the snippet node
export const EXPANDED_SNIPPET_NODE_GUTTER = 16;

// additional padding used for positioning nodes around a snippet node
export const EXPANDED_SNIPPET_Y_OFFSET = 16;
export const EXPANDED_SNIPPET_X_OFFSET = 8;

export const XL_NODE_FIRST_ROW_HOIST = 8;

// used for nodes that contain icons
export const NODE_HEIGHT_XL = 48;
export const NODE_TEXT_MAX_WIDTH = 140;
export const CHILD_NODE_WIDTH = 184;
export const NODE_HEIGHT = 32;
export const COLUMN_SPACING = 64;
export const ROW_SPACING = 16;
export const CANVAS_HORIZONTAL_PADDING = 1 * COLUMN_SPACING;
export const CANVAS_VERTICAL_PADDING = 2 * ROW_SPACING;
export const CANVAS_PANNING_PADDING_HORIZONTAL = CANVAS_HORIZONTAL_PADDING;
export const CANVAS_PANNING_PADDING_VERTICAL = CANVAS_VERTICAL_PADDING;
export const COMPLEX_ISLAND_PADDING = NODE_WIDTH + (COLUMN_SPACING / 2);
export const COMPLEX_ISLAND_WIDTH = 504;
// "in bounds" means that the size of the graph isn't larger than the canvas
// even with the Complex Island open
export const IN_BOUNDS_PADDING_WIDTH = (COLUMN_SPACING * 2);
// "out of bounds" means that the size of the graph is larger than the canvas
// even with the Complex Island open
export const OUT_OF_BOUNDS_PADDING_WIDTH = (COMPLEX_ISLAND_WIDTH + COLUMN_SPACING);
export const REQUIRED_SPACE_FOR_ISLAND_NODES = NODE_WIDTH;
export const TOTAL_REQUIRED_SPACE_FOR_SIMPLE_NODES_X = (
  COLUMN_SPACING + REQUIRED_SPACE_FOR_ISLAND_NODES + CANVAS_PANNING_PADDING_HORIZONTAL
);

// additional padding added to the left child node so that it aligned with the
// right edge of all other nodes
export const LEFT_CHILD_PADDING = NODE_WIDTH - CHILD_NODE_WIDTH;

// Node Editor Drawer:
export const NODE_EDITOR_DRAWER_HEIGHT_COLLAPSED = 380;
export const NODE_EDITOR_DRAWER_BOTTOM_MARGIN = 32;
export const SPACE_FOR_NODE_EDITOR_DRAWER = NODE_EDITOR_DRAWER_HEIGHT_COLLAPSED
  + NODE_EDITOR_DRAWER_BOTTOM_MARGIN;

// Vertical layers (zIndex) of elements in the canvas
export enum CanvasElementLayers {
  FADED_EDGES = -2,
  DEEMPHASIZED_EDGES = -1,
  EDGES = 0,
  NODES = 1,
  SNIPPET_EDGES = 2,
  SNIPPET_NODES = 3,
  FOCUSED_EDGES = 4,
  HOVERED_NODES = 5,
  PANELS = 6,
}

export const typeSortOrder: Record<WorkflowNodeType, number> = {
  // input attributes are children of the folder node so the ordering here is critical
  folder: 0,
  inputAttribute: 1,
  snippet: 2,
  riskCalculation: 3,
  // the order of the following nodes can be changed if desired
  service: 4,
  tag: 5,
  outputAttribute: 6,
  matrixModel: 7,
  // irrelevant for type sorting
  exit: 99,
  importedTailNode: 99,
  outcome: 99,
  outcomeReason: 99,
  preview: 99,
  skeleton: 99,
  workflow: 99,
};
